// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608071434/js/" + chunkId + "." + {"44":"081f570c","225":"252dcdbb","481":"40312a96","486":"f5218560","770":"7d999dcc"}[chunkId] + ".0.14956534273658317.chunk.js";
};